module.exports = __webpack_public_path__ + "static/media/icon-hover.c642e395.svg";